import React from "react";
import "./PartiesList.scss";
import {MDBIcon} from "mdbreact";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import OwlCarousel from "react-owl-carousel2";
import {withRouter} from "react-router-dom";
import {Zoom} from 'react-reveal'

const politcalSymbol = assetUrl + "images/similar-party-symbol.png";
const redBpLine = assetUrl + "images/icon_redBpLine.svg";
const greenBpLine = assetUrl + "images/icon_greenBpLine.svg";

function PartiesList(props) {
	const {part_data} = props;
	let options = {
		items: part_data.length > 1 ? 2 : 1,
		dots: false,
		rewind: true,
		autoplay: false,
		stagePadding: 1
	};

	const switchPartyHandler = (args) => {
		props.history.push(args)
		window.location.reload()
	}

	return (
		<div className={"parties-list-component"}>
			{
				part_data.length > 0 ?
					// <Zoom cascade delay={500}>
					<OwlCarousel options={options}>
						{
							part_data.map((item, index) => {

								return (
									<div onClick={() => switchPartyHandler("/party-detail/" + item.node.id)}
									     key={index}>
										<div className={"party-card"}>
											<img src={item.node.partyImage ? item.node.partyImage : politcalSymbol}
											     alt={"alt"} className={"party-symbol"}/>
											<p className={"party-name"}>{item.node.partyName}</p>
											{
												item.node.priceDiffPercentage >= 0 ?
													<div className={'d-flex align-items-center'}>
														<img src={greenBpLine} alt={"alt"}
														     className={"part-sign-icon"}/>
														<MDBIcon icon="caret-up" style={{color: profit_color}}/>
														<p className={"party-stock-price-diffrence"}
														   style={{color: profit_color}}>{item.node.priceDiffPercentage}%</p>
													</div>
													:
													<div className={'d-flex align-items-center'}>
														<img src={redBpLine} alt={"alt"}
														     className={"part-sign-icon"}/>
														<MDBIcon icon="caret-down" style={{color: loss_color}}/>
														<p className={"party-stock-price-diffrence"}
														   style={{color: loss_color}}>{item.node.priceDiffPercentage}%</p>
													</div>
											}

										</div>
									</div>
								);
							})
						}
					</OwlCarousel>
					// </Zoom>
					:
					<div className={"error-section"}>No Datas Found</div>
			}
		</div>
	);
};

export default withRouter(PartiesList);